import { api_GET, api_GET_Unauthorize } from "./_api.js";

const setup_api = {
    GetVariaveisSetup: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Setup/GetVariaveisSetup`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetLogotiposPrefeituraSidebar: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Setup/GetLogotiposPrefeituraSidebar`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetLogotiposPrefeituraHome: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`Setup/GetLogotiposPrefeituraHome`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    }
}
export default setup_api;